const STYLE_NONCE_ATTRIBUTE_PATTERN = /\snonce=(['"]).*?\1/gi;
const STYLE_OPEN_TAG_PATTERN = /<style\b([^>]*)>/gi;
export const getCspNonce = () => {
    const nonce = document
        .querySelector('meta[name="csp-nonce"]')
        ?.content
        ?.trim();
    return nonce && nonce !== '__CSP_NONCE__' ? nonce : undefined;
};
export const addNonceToStyleElements = (content) => {
    if (typeof content !== 'string') {
        return '';
    }
    const nonce = getCspNonce();
    if (!nonce) {
        return content;
    }
    return content.replace(STYLE_OPEN_TAG_PATTERN, (_match, attributes = '') => {
        const normalizedAttributes = attributes.replace(STYLE_NONCE_ATTRIBUTE_PATTERN, '');
        return `<style${normalizedAttributes} nonce="${nonce}">`;
    });
};
export const stripNonceFromStyleElements = (content) => {
    return content.replace(/(<style\b[^>]*?)\snonce=(['"]).*?\2([^>]*>)/gi, '$1$3');
};
